import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';

import { isCatalogedApiErrorCode } from '@/features/audit-issues';

/**
 * Localized, `role="alert"` notice for a server-declared truck-photo
 * conflict adjacent to the affected card (spec-13 §8.7). Shared between the
 * inbound lot detail page and the DEV-only tooling so the two can never
 * drift apart.
 */
export const TruckPhotoConflictNotice = ({ code }: { code: string }) => {
  const { t } = useTranslation(['issues']);
  return (
    <p
      role="alert"
      className="flex items-start gap-1 rounded border border-red-400 bg-red-50 px-2 py-1 text-[11px] font-medium text-red-800 dark:border-red-700 dark:bg-red-950 dark:text-red-100"
    >
      <AlertTriangle className="mt-0.5 h-3 w-3 shrink-0" aria-hidden="true" />
      <span>
        {isCatalogedApiErrorCode(code)
          ? t(`efs.issues.errors.${code}`)
          : t('efs.issues.errors.UNKNOWN_ERROR')}
      </span>
    </p>
  );
};
